import type {InputTypes} from '../../../core/entities/reports/constants';
import type {QuestionAnswerType} from '../../../core/entities/reports/schema';

type QuestionAnswerListForUI = {
  label: string;
  value: string;
  inputType?: InputTypes;
};
export const listSelectionReportQuestionAnswer = (
  QuestionAnswers: QuestionAnswerType[],
) => {
  return QuestionAnswers.map((qa) => {
    const questionAnswerForUI: QuestionAnswerListForUI = {
      label: qa.question,
      value: qa.answer,
      inputType: qa.inputType,
    };
    return questionAnswerForUI;
  });
};
